import { createRoutine } from 'redux-saga-routines';
import { GET_ONTHISDAY } from './constants';

export const getOnthisdayAction = createRoutine(GET_ONTHISDAY);
